import WestDesMoinesHeroSection from "./components/HeroSection";
import WestDesMoinesStickyNav from "./components/StickyNav";
import WestDesMoinesProcessingTimeSection from "./components/ProcessingTimeSection";
import WestDesMoinesServicesSection from "./components/ServicesSection";
import WestDesMoinesLocalAreaSection from "./components/LocalAreaSection";
import WestDesMoinesTestimonialsSection from "./components/TestimonialsSection";
import WestDesMoinesAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import WestDesMoinesComparisonSection from "./components/ComparisonSection";
import WestDesMoinesMistakesSection from "./components/MistakesSection";
import WestDesMoinesHowItWorksSection from "./components/HowItWorksSection";
import WestDesMoinesFAQSection, { faqs } from "./components/FAQSection";
import WestDesMoinesHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import WestDesMoinesFinalCTA from "./components/FinalCTA";
import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function WestDesMoinesPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="West Des Moines"
        state="Iowa"
        stateAbbr="IA"
        route="/cities/west-des-moines"
        title="Emergency Passport West Des Moines, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in West Des Moines, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Jordan Creek corporate travelers, insurance professionals, and Dallas County families."
        geoPlacename="West Des Moines, Iowa"
        geoPosition="41.5772;-93.7592"
        faqs={faqs}
        servicesSchema={[]}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
      />
      <WestDesMoinesHeroSection />
      <WestDesMoinesStickyNav />
      <WestDesMoinesProcessingTimeSection />
      <WestDesMoinesLocalAreaSection />
      <WestDesMoinesServicesSection />
      <WestDesMoinesTestimonialsSection />
      <WestDesMoinesAcceptanceFacilitiesSection />
      <WestDesMoinesComparisonSection />
      <WestDesMoinesMistakesSection />
      <WestDesMoinesHowItWorksSection />
      <WestDesMoinesFAQSection />
      <WestDesMoinesHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/west-des-moines" state="IA" />
      <WestDesMoinesFinalCTA />
    </div>
  );
}